import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }

import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import Card from 'primevue/card'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import OperationalList from './OperationalList.vue'
import PPList from './PPList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const title = ref('Kupon BBM')
const titleButton = ref('Tambah Kupon')
const router = useRouter()
const store = useStore()
const positionTabs = ref(0)
const usedCouponCount = ref(0)
const tabHeader = computed(() => [
  { title: 'Operasional', value: 0, hasCount: true, count: usedCouponCount.value },
  { title: 'Pengisian PP', value: 1, hasCount: false, count: 0 }
])

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [['category', '=', 'Operational'], ['IsNeedToApprove', '=', 'true']]
})

const tabsChange = (val: any) => {
  positionTabs.value = val
}

const getUsedCouponCount = async () => {
  const fuelVouchersEndpoint = '/transaction/v2/FuelTransactionVouchers'
  store.dispatch('showLoading')
  await apiUseCase.get(`${fuelVouchersEndpoint}${returnUrlPrams(filters.value)}`).then((response) => {
    const { count, result, error } = response
    if (!error) {
      usedCouponCount.value = count
    }
  })
  store.dispatch('hideLoading')
}

const redirectAdd = () => {
  console.log('asdsada')
  router.push({
    name: 'master-fuel-coupon-form'
  })
}

onMounted(() => {
  getUsedCouponCount()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: title.value,
            titleButton: titleButton.value,
            onRedirectAdd: _cache[0] || (_cache[0] = ($event: any) => (redirectAdd())),
            showSearch: false
          }, null, 8, ["titleHeader", "titleButton"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(HjpTabView, {
          onTabsChange: tabsChange,
          tabHeader: _unref(tabHeader),
          currActive: positionTabs.value
        }, null, 8, ["tabHeader", "currActive"]),
        (positionTabs.value === 0)
          ? (_openBlock(), _createBlock(OperationalList, { key: 0 }))
          : _createCommentVNode("", true),
        (positionTabs.value === 1)
          ? (_openBlock(), _createBlock(PPList, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})